namespace Matrix.Workflow {
    export namespace WorkflowInstanceLogService {
        export const baseUrl = 'Workflow/WorkflowInstanceLog';

        export declare function Create(request: Serenity.SaveRequest<WorkflowInstanceLogRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WorkflowInstanceLogRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WorkflowInstanceLogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WorkflowInstanceLogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Workflow/WorkflowInstanceLog/Create",
            Update = "Workflow/WorkflowInstanceLog/Update",
            Delete = "Workflow/WorkflowInstanceLog/Delete",
            Retrieve = "Workflow/WorkflowInstanceLog/Retrieve",
            List = "Workflow/WorkflowInstanceLog/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>WorkflowInstanceLogService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
